import { useMainStore } from '@/store/index'
import { ref } from 'vue'

export const useSocialFeed = (propertyId = null) => {
  const store = useMainStore()
  const feed = ref([])
  const loading = ref(false)
  const error = ref(null)

  const loadSocialFeed = async (limit = 6) => {
    loading.value = true
    error.value = null

    try {
      const baseUrl = propertyId
        ? `https://api.mallmaverick.com/properties/${propertyId}/`
        : store.baseURL
      const response = await $fetch(`${baseUrl}get_instagram_feeds`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })

      feed.value = Array.isArray(response.data)
        ? response.data.slice(0, limit)
        : []

    } catch (err) {
      console.error('Failed to load Instagram feed:', err)
      error.value = err
    } finally {
      loading.value = false
    }
  }

  return {
    feed,
    loading,
    error,
    loadSocialFeed,
  }
}

